import React, { useEffect, useState, useMemo, memo } from 'react';
import { CheckBox, LoadIndicator } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Popup } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import { useScreenSize } from '../../../../utils/media-query';
import { useApiConfigUsuarios } from '../../../../api/api.ConfigUsuarios';
import { getGroupedPermissions } from './functions';
import { ToolbarItem } from 'devextreme-react/popup';

interface PermissionsModalProps {
  isModalVisible: boolean;
  setIsModalVisible: (visible: boolean) => void;
  perfil: string;
  idPermiso: number;
}

const ModalPermissionsModalComponent = ({ isModalVisible, setIsModalVisible, perfil, idPermiso }: PermissionsModalProps) => {
  const [permissions, setPermissions] = useState<any[]>([]);
  const [searchText, setSearchText] = useState('');
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const { setPermisos, getPermisos } = useApiConfigUsuarios();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isModalVisible) {
      getPermisos(idPermiso).then((res) => {
        const groupedPermissions = getGroupedPermissions(res);
        setPermissions(groupedPermissions);
      });
      setSearchText('');
    }
  }, [isModalVisible]);

  const filteredPermissions = useMemo(() => {
    if (!searchText.trim()) {
      return permissions;
    }

    const searchLower = searchText.toLowerCase();
    return permissions
      .map((group) => ({
        ...group,
        Items: group.Items.filter((item) => item.label.toLowerCase().includes(searchLower) || group.GrouName.toLowerCase().includes(searchLower)),
      }))
      .filter((group) => group.Items.length > 0);
  }, [permissions, searchText]);

  const onSave = () => {
    const updatedPermissions = permissions.reduce((acc, group) => {
      group.Items.forEach((item) => {
        acc[item.property] = item.value;
      });
      return acc;
    }, {});

    setLoading(true);
    updatedPermissions.Prm_Id = idPermiso;
    setPermisos({ Permiso: updatedPermissions }).finally(() => {
      setLoading(false);
      setIsModalVisible(false);
    });
  };

  return (
    <Popup visible={isModalVisible} onHiding={() => setIsModalVisible(false)} maxHeight={'90%'} dragEnabled={false} showCloseButton={true} showTitle={true} title={`Configurar Permisos - ${perfil}`} width={800} fullScreen={isMedium || isSmall || isXSmall} height={'auto'}>
      <div>
        <div style={{ marginBottom: '20px' }}>
          <TextBox placeholder='Buscar permisos...' mode='search' valueChangeEvent='keyup' value={searchText} onValueChanged={(e) => setSearchText(e.value)} showClearButton={true} />
        </div>

        {filteredPermissions.map((group) => (
          <React.Fragment key={group.GrouName}>
            <div style={{ marginTop: '20px', marginBottom: '10px' }}>
              <h3>{group.GrouName}</h3>
            </div>

            <div className='permission-group'>
              {group.Items.map((permission) => (
                <div
                  key={permission.property}
                  style={{
                    display: 'inline-block',
                    width: isMedium || isSmall || isXSmall ? '100%' : 'calc(33.33% - 10px)',
                    marginBottom: '10px',
                    paddingRight: '10px',
                    paddingLeft: '10px',
                  }}>
                  <CheckBox
                    value={permission.value}
                    text={permission.label}
                    onValueChanged={(e) => {
                      const updatedPermissions = [...permissions];
                      const groupIndex = updatedPermissions.findIndex((g) => g.GrouName === group.GrouName);
                      const permissionIndex = updatedPermissions[groupIndex].Items.findIndex((p) => p.property === permission.property);
                      updatedPermissions[groupIndex].Items[permissionIndex].value = e.value;
                      setPermissions(updatedPermissions);
                    }}
                  />
                </div>
              ))}
            </div>
          </React.Fragment>
        ))}

        {filteredPermissions.length === 0 && searchText && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
            <p>No se encontraron permisos que coincidan con "{searchText}"</p>
          </div>
        )}
      </div>

      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container `}>
          <Button stylingMode='contained' type={loading ? 'normal' : 'default'} disabled={loading} onClick={onSave}>
            <div style={{ padding: 8 }}>
              <span className='dx-button-text' style={{ marginRight: loading ? 10 : 0 }}>
                {loading ? 'Guardando...' : 'Guardar Cambios'}
              </span>
              <LoadIndicator className='button-indicator' height={15} width={15} style={{ marginLeft: 20, marginRigth: 20 }} visible={loading} />
            </div>
          </Button>
        </div>
      </ToolbarItem>
    </Popup>
  );
};

export const ModalPermissionsModal = memo(ModalPermissionsModalComponent);
